import { PageLocatorMap } from '../types/PageLocatorMap';

export const mailCodePage = {
  alert: {
    error: 'mail-code-page.alert.error',
  },
  footer: {
    root: 'mail-code-page.footer.root',
  },
  form: {
    h1: 'mail-code-page.form.heading1',
    h2: 'mail-code-page.form.heading2',
    mailCodeInput: 'mail-code-page.form.mail-code-input',
    mailCodeInputError: 'mail-code-page.form.mail-code-error',
    root: 'mail-code-page.form.root',
    signupLink: 'mail-code-page.form.signup-link',
    submitButton: 'mail-code-page.form.submit-button',
  },
} as const satisfies PageLocatorMap;
